import { render, staticRenderFns } from "./StoryStatisticTipItem.vue?vue&type=template&id=3b08db4e&scoped=true&"
import script from "./StoryStatisticTipItem.vue?vue&type=script&lang=ts&"
export * from "./StoryStatisticTipItem.vue?vue&type=script&lang=ts&"
import style0 from "./StoryStatisticTipItem.vue?vue&type=style&index=0&id=3b08db4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b08db4e",
  null
  
)

export default component.exports